// extracted by mini-css-extract-plugin
export var numpadContainer = "_rq-1";
export var phoneButton = "_rq-0";